import React from 'react'
import styled from 'styled-components'
import useMboxCall from '@ally/use-mbox-call'
import { Box } from '@ally/metronome-ui'
import TipsMbox from './TipsMbox'

const Wrapper = styled(Box)`
  ${({ theme: { colors, space } }): string => `
    padding: ${space.sm};
    margin-bottom: ${space.md};
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16);
    border: 1px solid ${colors['slate-2']};
    border-radius: 4px;
  `};
`

export const List = styled.ul`
  ${({ theme: { colors, space } }): string => `
  padding: 0;
  margin: 0;
  line-height: 1.5;

    & ~ & {
      margin-top: ${space.sm};
      padding-top: ${space.sm};
      border-top: 1px solid ${colors['slate-2']};
    }
  `};
`

export const ListItem = styled.li`
  ${({ theme: { colors, space } }): string => `
    align-items: center;
    list-style: none;
    display: flex;
    padding: ${space.sm} 0;
    border-bottom: 1px solid ${colors['slate-2']};

    &:first-of-type {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  `};
`

const TipsAndOpportunities: React.FC<{ productId: number }> = ({
  productId,
}) => {
  const detailsTip = useMboxCall(
    `ally-account-details-tips-${productId}-01`,
    [],
  ).mboxData

  if (detailsTip && detailsTip[0]) {
    detailsTip[0].trackingName = `ally-account-details-tips-${productId}-01`
  }
  const tipArray = [detailsTip]

  return (
    <>
      {detailsTip && detailsTip[0] && (
        <Wrapper data-testid="tips-mbox">
          <TipsMbox adobeTip={tipArray} />
        </Wrapper>
      )}
    </>
  )
}

export default TipsAndOpportunities
